'use client'
import { useState, useEffect } from 'react'

export function Logo() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const scrollContainer = document.querySelector('.marbles-game')

    if (!scrollContainer) {
      return
    }

    const handleScroll = () => {
      setIsScrolled(scrollContainer.scrollTop > 0)
    }

    // Check initial scroll position
    handleScroll()

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={`primary-logo ${isScrolled ? 'scrolled' : ''}`} data-scrolled={isScrolled} />
  )
}

export default Logo
